import * as React from 'react'
import {ChangeEvent, Component, ReactElement} from 'react'
import {Box, Collapse} from '@mui/material'
import {NatApplicationRepo} from '../../repository/NatApplicationRepo'
import {BlockSpacer, currentMedia, GridContainer, GridItem} from '../../../../../styledComponents/ResponsiveConvenience'
import {
    FlexContainer,
    FullWidthColumnFlexContainer,
    FullWidthRowFlexContainer,
    LeftColumnFlexContainer,
    LeftRowFlexContainer,
    RightColumnFlexContainer,
    StretchRowFlexContainer,
} from '../../../../../styledComponents/FlexComponents'
import {convertToRoomNumberForResident, toFullWidthNumber} from '../../../../common/util/Natutil'
import NatCurrentDateTimeRepo from '../../../currentDateTime/repository/NatCurrentDateTimeRepo'
import moment from 'moment'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey,
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {ApplyButton, ItemHeading, WideWhiteArea} from '../../common/resident/NatResidentApplicationsCommon'
import {NatGetCurrentDateTime} from '../../../currentDateTime/repository/NatGetCurrentDateTime'
import {
    NatBrowseApplyAccompany,
    NatBrowseApplyTime,
    NatResidentBrowseLocationState,
} from '../NatResidentApplicationInterface'
import {Nullable} from '../../../../../app/TypeHelpers'
import EventEmitterExResident from '../../../../../components/shared/pageBaseComponents/EventEmitterExResident'
import NatCondominiumRepo from '../../../condominium/repository/NatCondominiumRepo'
import NatResidentApplicationDetailFormItem from '../../common/resident/NatResidentApplicationDetailFormItem'
import HolidaysRepository from '../../../../../components/HolidaysRepository'
import {AsyncCallFunctionType} from '../../../../../components/shared/hoc/withAsyncCommunication'
import {PPTextFieldForResident} from '../../../../../components/shared/forms/resident/PPTextFieldForResident'
import PPDatePickerForResident from '../../../../../components/shared/forms/resident/PPDatePickerForResident'
import {HKConstants} from '../../../../../HKConstants'
import ErrorMessageAreaWrapper from '../../../../../components/shared/forms/resident/ErrorMessageAreaWrapper'
import {NatZipCode} from '../../../condominium/repository/NatZipCode'
import {RequestItemError} from '../../../../../network/response/RequestItemError'
import {Messages} from '../../../../../Messages'
import {PPTextAreaForResident} from '../../../../../components/shared/forms/resident/PPTextAreaForResident'
import {NatPutBrowseRequest} from '../../repository/NatPutBrowse'
import PPSelectForResident from '../../../../../components/shared/forms/resident/PPSelectForResident'
import {HOURS, RESERVATION_TIME_UNIT_MINUTES} from '../../../../../CodeMaster'
import {addEmptyData, NoSelectedValue} from '../../../../../componentHelper/selectHelper'
import {OptionProps} from '../../../../../components/shared/forms/PPSelect'
import {TransitionGroup} from 'react-transition-group'
import {AddCircle, Clear} from '@mui/icons-material'
import {DefaultStyledButton, UnstyledLinkStyledButton} from '../../../../../styledComponents/Button'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../../../../styledComponents/Constants'
import {Location, NavigateFunction} from 'react-router-dom'

interface Props {
    condominiumCd: string
    applicationRepo: NatApplicationRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    condominiumRepo: NatCondominiumRepo
    holidaysRepo: HolidaysRepository
    navigate: NavigateFunction
    location: Location<NatResidentBrowseLocationState>
    eventEmitter: EventEmitterExResident
    asyncCallFunction: AsyncCallFunctionType

    applicantFamilyName: Nullable<string>
    applicantFirstName: Nullable<string>
    browseReasonDetail: Nullable<string>
    videoRecordingPlace: Nullable<string>
    videoRecordingDate: Nullable<string>
    videoRecordingStartTime: Nullable<NatBrowseApplyTime>
    videoRecordingEndTime: Nullable<NatBrowseApplyTime>
    browsePreferredDate: Nullable<string>
    browsePreferredStartTime: Nullable<NatBrowseApplyTime>
    browsePreferredEndTime: Nullable<NatBrowseApplyTime>
    accompanyList: Nullable<NatBrowseApplyAccompany[]>
    note: Nullable<string>

    submitButtonLabel: string
    onClickApplyConfirmButton: (applyRequest: NatPutBrowseRequest) => Promise<void>
}

interface State {
    applicantFamilyName: string
    applicantFirstName: string
    browseReasonDetail: string
    videoRecordingPlace: string
    videoRecordingDate: string
    videoRecordingStartTime: NatBrowseApplyTime
    videoRecordingEndTime: NatBrowseApplyTime
    browsePreferredDate: string
    browsePreferredStartTime: NatBrowseApplyTime
    browsePreferredEndTime: NatBrowseApplyTime
    accompanyList: Accompany[]
    note: string

    currentDate: moment.Moment
    holidays: string[]

    clearErrorKeys: Set<keyof State>
    applyButtonDisabled: boolean
    isLoadCompleted: boolean
}

interface Accompany {
    key: number
    index: number
    relationship: string
    accompanyName: string
    zipCode: string
    prefecture: string
    address2: string
    address3: string
    buildingRoomNumber: string
}

interface Address {
    prefecture: string
    address2: string
    address3: string
}

export default class NatResidentBrowseForm extends Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            applicantFamilyName: '',
            applicantFirstName: '',
            browseReasonDetail: '',
            videoRecordingPlace: '',
            videoRecordingDate: '',
            videoRecordingStartTime: {
                time: '',
                hours: '',
                minutes: '',
            },
            videoRecordingEndTime: {
                time: '',
                hours: '',
                minutes: '',
            },
            browsePreferredDate: '',
            browsePreferredStartTime: {
                time: '',
                hours: '',
                minutes: '',
            },
            browsePreferredEndTime: {
                time: '',
                hours: '',
                minutes: '',
            },
            accompanyList: [],
            note: '',
            currentDate: moment(),
            holidays: [],
            clearErrorKeys: new Set<keyof State>(),
            applyButtonDisabled: true,
            isLoadCompleted: false,
        }

        this.handleChangeText = this.handleChangeText.bind(this)
        this.handleChangeHours = this.handleChangeHours.bind(this)
        this.handleChangeMinutes = this.handleChangeMinutes.bind(this)

        this.handleChangeVideoRecordingDate = this.handleChangeVideoRecordingDate.bind(this)
        this.handleChangeBrowsePreferredDate = this.handleChangeBrowsePreferredDate.bind(this)
        this.handleChangeAccompanyText = this.handleChangeAccompanyText.bind(this)
        this.onClickAddFamilyButton = this.onClickAddFamilyButton.bind(this)
        this.onClickDeleteFamilyButton = this.onClickDeleteFamilyButton.bind(this)

        this.onClickApplyConfirmButton = this.onClickApplyConfirmButton.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()

        try {
            const [currentTimeResponse, holidays] = await Promise.all([
                this.getCurrentDateTime(),
                this.getHoliday(),
            ])

            if (currentTimeResponse && currentTimeResponse.details) {
                this.setState({
                    currentDate: moment(currentTimeResponse.details.currentDateTime),
                })
            }

            const applicantFamilyName = this.props.applicantFamilyName ?? this.state.applicantFamilyName
            const applicantFirstName = this.props.applicantFirstName ?? this.state.applicantFirstName
            const browseReasonDetail = this.props.browseReasonDetail ?? this.state.browseReasonDetail
            const videoRecordingPlace = this.props.videoRecordingPlace ?? this.state.videoRecordingPlace
            const videoRecordingDate = this.props.videoRecordingDate ?? this.state.videoRecordingDate
            const videoRecordingStartTime = this.props.videoRecordingStartTime ?? this.state.videoRecordingStartTime
            const videoRecordingEndTime = this.props.videoRecordingEndTime ?? this.state.videoRecordingEndTime
            const browsePreferredDate = this.props.browsePreferredDate ?? this.state.browsePreferredDate
            const browsePreferredStartTime = this.props.browsePreferredStartTime ?? this.state.browsePreferredStartTime
            const browsePreferredEndTime = this.props.browsePreferredEndTime ?? this.state.browsePreferredEndTime
            const accompanyList = this.props.accompanyList ?? this.state.accompanyList
            const note = this.props.note ?? this.state.note

            const keyAddAccompanyList: Nullable<Accompany[]> = accompanyList?.map(accompany => {
                return {
                    key: Math.random(),
                    index: accompany.index,
                    relationship: accompany.relationship ?? '',
                    accompanyName: accompany.accompanyName ?? '',
                    zipCode: accompany.zipCode ?? '',
                    prefecture: accompany.prefecture ?? '',
                    address2: accompany.address2 ?? '',
                    address3: accompany.address3 ?? '',
                    buildingRoomNumber: accompany.buildingRoomNumber ?? '',
                }
            }) ?? null

            this.setState({
                applicantFamilyName: applicantFamilyName,
                applicantFirstName: applicantFirstName,
                browseReasonDetail: browseReasonDetail,
                videoRecordingPlace: videoRecordingPlace,
                videoRecordingDate: videoRecordingDate,
                videoRecordingStartTime: videoRecordingStartTime,
                videoRecordingEndTime: videoRecordingEndTime,
                browsePreferredDate: browsePreferredDate,
                browsePreferredStartTime: browsePreferredStartTime,
                browsePreferredEndTime: browsePreferredEndTime,
                accompanyList: keyAddAccompanyList,
                note: note,
                holidays: holidays === null ? [] : holidays,
            }, () => {
                this.updateApplyConfirmButtonDisabled()
            })
        } finally {
            this.setState({isLoadCompleted: true})
        }
        this.props.eventEmitter.closeLoading()
    }

    async getCurrentDateTime(): Promise<Nullable<NatGetCurrentDateTime>> {
        const {currentDateTimeRepo, eventEmitter} = this.props

        return await this.props.asyncCallFunction(
            currentDateTimeRepo.getCurrentDateTime.bind(currentDateTimeRepo),
            async (httpErrorOrNetworkError) => {
                await httpErrorOrNetworkError.broadcast(eventEmitter)
            },
        )
    }

    async getHoliday(): Promise<Nullable<string[]>> {
        const {holidaysRepo, eventEmitter} = this.props

        const minDate: string = HKConstants.CMN.SYC.MIN_HOLIDAY_DATE
        const maxDate: string = HKConstants.CMN.SYC.MAX_HOLIDAY_DATE
        return await this.props.asyncCallFunction(
            holidaysRepo.getHolidays.bind(holidaysRepo, minDate, maxDate),
            async (httpErrorOrNetworkError) => {
                await httpErrorOrNetworkError.broadcast(eventEmitter)
            },
        )
    }

    handleChangeText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name as keyof State
        const value: string = event.target.value
        this.setState({...this.state, [key]: value}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeVideoRecordingDate(date: string): void {
        this.setState({videoRecordingDate: date}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeBrowsePreferredDate(date: string): void {
        this.setState({browsePreferredDate: date}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeHours(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name as keyof State
        const value: string = event.target.value
        const timeState = this.state[key] as NatBrowseApplyTime
        timeState.hours = value

        const clearErrorKeys = this.state.clearErrorKeys
        clearErrorKeys.add(key)

        this.setState({...this.state, ...timeState, clearErrorKeys: clearErrorKeys}, () => {
            this.updateTime()
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeMinutes(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name as keyof State
        const value: string = event.target.value
        const timeState = this.state[key] as NatBrowseApplyTime
        timeState.minutes = value

        const clearErrorKeys = this.state.clearErrorKeys
        clearErrorKeys.add(key)

        this.setState({...this.state, ...timeState, clearErrorKeys: clearErrorKeys}, () => {
            this.updateTime()
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeAccompanyText(event: ChangeEvent<HTMLInputElement>): void {
        const {accompanyList} = this.state
        const key = event.target.name.substring(event.target.name.indexOf('')).slice(13) as keyof State
        const value: string = event.target.value
        const index = Number(event.target.dataset.familyindex)
        accompanyList[index] = {...accompanyList[index], ...{[key]: value}}

        this.setState({accompanyList: accompanyList}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    onClickAddFamilyButton(): void {
        const {accompanyList} = this.state

        accompanyList.push(
            {
                index: accompanyList.length,
                relationship: '',
                accompanyName: '',
                zipCode: '',
                prefecture: '',
                address2: '',
                address3: '',
                buildingRoomNumber: '',
                key: Math.random(),
            },
        )
        this.setState({accompanyList: accompanyList}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    onClickDeleteFamilyButton(index: number): void {
        const {accompanyList} = this.state
        const updatedAccompanyList: Accompany[] = []

        accompanyList.forEach((accompany) => {
            const tmpAccompany: Accompany = accompany
            if (accompany.index !== index) {
                tmpAccompany.index = updatedAccompanyList.length
                updatedAccompanyList.push(tmpAccompany)
            }
        })

        this.setState({accompanyList: updatedAccompanyList}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    updateApplyConfirmButtonDisabled(): void {
        const {
            applicantFamilyName,
            applicantFirstName,
            browseReasonDetail,
            videoRecordingPlace,
            videoRecordingDate,
            videoRecordingStartTime,
            videoRecordingEndTime,
            browsePreferredDate,
            browsePreferredStartTime,
            browsePreferredEndTime,
        } = this.state

        let applyButtonDisabled = false

        if (!applicantFamilyName || !applicantFirstName || !browseReasonDetail || !videoRecordingPlace ||
            !videoRecordingDate || !videoRecordingStartTime.time || !videoRecordingEndTime.time ||
            !browsePreferredDate || !browsePreferredStartTime.time || !browsePreferredEndTime.time) {
            applyButtonDisabled = true
        }
        this.setState({applyButtonDisabled: applyButtonDisabled})
    }

    updateTime(): void {
        const {
            videoRecordingStartTime,
            videoRecordingEndTime,
            browsePreferredStartTime,
            browsePreferredEndTime,
        } = this.state

        videoRecordingStartTime.time = this.getFormattedTime(videoRecordingStartTime)
        videoRecordingEndTime.time = this.getFormattedTime(videoRecordingEndTime)
        browsePreferredStartTime.time = this.getFormattedTime(browsePreferredStartTime)
        browsePreferredEndTime.time = this.getFormattedTime(browsePreferredEndTime)

        this.setState({
            videoRecordingStartTime: videoRecordingStartTime,
            videoRecordingEndTime: videoRecordingEndTime,
            browsePreferredStartTime: browsePreferredStartTime,
            browsePreferredEndTime: browsePreferredEndTime,
        })
    }

    getFormattedTime(time: NatBrowseApplyTime): string {
        if (time.hours && time.minutes) {
            return `${time.hours}:${time.minutes}`
        }
        return ''
    }

    getSelectedTime(value: string): string {
        return value ? value : NoSelectedValue
    }

    getSelectableHours(value: string): OptionProps[] {
        const data: OptionProps[] = HOURS.values().map(item => {
            return {
                label: item.label,
                value: item.value,
            }
        })

        return value ? data : addEmptyData(data, '時')
    }

    getSelectableMinutes(value: string): OptionProps[] {
        const data: OptionProps[] = RESERVATION_TIME_UNIT_MINUTES.values().map(item => {
            return {
                label: ('0' + item.label).slice(-2),
                value: ('0' + item.value).slice(-2),
            }
        })

        return value ? data : addEmptyData(data, '分')
    }

    async onClickApplyConfirmButton(): Promise<void> {
        const {
            applicantFamilyName,
            applicantFirstName,
            browseReasonDetail,
            videoRecordingPlace,
            videoRecordingDate,
            videoRecordingStartTime,
            videoRecordingEndTime,
            browsePreferredDate,
            browsePreferredStartTime,
            browsePreferredEndTime,
            accompanyList,
            note,
        } = this.state

        this.setState({clearErrorKeys: new Set<keyof State>()})

        const accompanyParam = accompanyList.map(accompany => {
            return {
                index: accompany.index,
                relationship: accompany.relationship || null,
                accompanyName: accompany.accompanyName || null,
                zipCode: accompany.zipCode || null,
                prefecture: accompany.prefecture || null,
                address2: accompany.address2 || null,
                address3: accompany.address3 || null,
                buildingRoomNumber: accompany.buildingRoomNumber || null,
            }
        })

        const applyRequest: NatPutBrowseRequest = {
            applicantFamilyName: applicantFamilyName,
            applicantFirstName: applicantFirstName,
            browseReasonDetail: browseReasonDetail,
            videoRecordingPlace: videoRecordingPlace,
            videoRecordingDate: videoRecordingDate,
            videoRecordingStartTime: videoRecordingStartTime.time,
            videoRecordingEndTime: videoRecordingEndTime.time,
            browsePreferredDate: browsePreferredDate,
            browsePreferredStartTime: browsePreferredStartTime.time,
            browsePreferredEndTime: browsePreferredEndTime.time,
            accompany: accompanyParam.length > 0 ? accompanyParam : null,
            note: note || null,
            confirmed: false,
        }

        await this.props.onClickApplyConfirmButton(applyRequest)
    }

    async getAccompanyZipCode(key: number): Promise<void> {
        const accompanyList = this.state.accompanyList

        const address: Nullable<Address> = await this.getAddressFromZipCode(
            accompanyList[key].zipCode,
            `accompany[${accompanyList[key].index}].zipCode`,
        )
        if (address) {
            accompanyList[key].prefecture = address.prefecture
            accompanyList[key].address2 = address.address2
            accompanyList[key].address3 = address.address3
        }
        this.setState({accompanyList: accompanyList}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    async getAddressFromZipCode(zipCode: string, resultCode: string): Promise<Nullable<Address>> {
        const {condominiumRepo} = this.props
        let address: Nullable<Address> = null
        await this.props.eventEmitter.showLoading()

        try {
            // 桁数不正の場合、単純に結果が取得できないので特に事前チェックは行わない
            const firstPart = zipCode.substr(0, 3)
            const lastPart = zipCode.substr(3, zipCode.length - 1)

            await condominiumRepo.getZipCode(firstPart, lastPart).then(
                zipData => {
                    const zipCodeResponse: NatZipCode = zipData

                    if (zipCodeResponse && zipCodeResponse.data
                        && zipCodeResponse.data[0] && zipCodeResponse.data[0].ja) {
                        address = {
                            prefecture: zipCodeResponse.data[0].ja.prefecture,
                            address2: zipCodeResponse.data[0].ja.address1,
                            address3: zipCodeResponse.data[0].ja.address2,
                        }
                    }

                    if (zipCodeResponse && zipCodeResponse.data
                        && zipCodeResponse.data.length > 1) {
                        const requestItemError = new RequestItemError(
                            'zipCode', Messages.WCONA0002.toString(), 'WCONA0002')
                        this.props.eventEmitter.emit(resultCode, requestItemError)

                    }
                },
            ).catch(
                () => {
                    const requestItemError = new RequestItemError(
                        'zipCode', Messages.ECONA0001.toString(), 'ECONA0001')
                    this.props.eventEmitter.emit(resultCode, requestItemError)
                },
            )
        } finally {
            this.props.eventEmitter.closeLoading()
        }
        return address
    }

    renderApplicantForm(): ReactElement {
        const {applicantFamilyName, applicantFirstName} = this.state

        const applicantRoom = NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
            convertToRoomNumberForResident(
                NatResidentLoginInfoSessionStorageHelper
                    .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER),
            )

        return (
            <>
                <ItemHeading>
                    申請者
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    {applicantRoom}
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'氏名'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'applicantFamilyName',
                                        maxLength: 10,
                                        value: applicantFamilyName,
                                        placeholder: '例：素敵',
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['applicantFamilyName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'applicantFirstName',
                                        maxLength: 10,
                                        placeholder: '例：太郎',
                                        value: applicantFirstName,
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['applicantFirstName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderBrowseReasonDetailForm(): ReactElement {
        const {browseReasonDetail} = this.state

        return (
            <>
                <ItemHeading>
                    閲覧理由
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'閲覧理由の詳細'}
                        required
                        component={
                            <PPTextAreaForResident
                                inputProps={{
                                    maxLength: 200,
                                    name: 'browseReasonDetail',
                                    value: browseReasonDetail,
                                    placeholder: '200文字以内',
                                }}
                                onChange={this.handleChangeText}
                                eventKeys={['browseReasonDetail']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderConstructionDateForm(): ReactElement {
        const {
            videoRecordingPlace,
            videoRecordingDate,
            videoRecordingStartTime,
            videoRecordingEndTime,
            currentDate,
            holidays,
        } = this.state

        return (
            <>
                <ItemHeading>
                    閲覧したい録画映像
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'場所'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 30,
                                    name: 'videoRecordingPlace',
                                    value: videoRecordingPlace,
                                    placeholder: '例：エントランス',
                                }}
                                onChange={this.handleChangeText}
                                eventKeys={['videoRecordingPlace']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'日付'}
                        required
                        component={
                            <PPDatePickerForResident
                                date={videoRecordingDate}
                                onChange={this.handleChangeVideoRecordingDate}
                                holidays={holidays}
                                itemValue={''}
                                eventKeys={['videoRecordingDate']}
                                eventEmitter={this.props.eventEmitter}
                                today={currentDate.toDate()}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'開始時間'}
                        required
                        component={
                            <ErrorMessageAreaWrapper>
                                <FlexContainer>
                                    <Box width={'50%'} minWidth={0}>
                                        <PPSelectForResident
                                            inputProps={{
                                                name: 'videoRecordingStartTime',
                                                value: this.getSelectedTime(videoRecordingStartTime.hours),
                                            }}
                                            onChange={this.handleChangeHours}
                                            options={this.getSelectableHours(videoRecordingStartTime.hours)}
                                            eventKeys={[`videoRecordingStartTime`]}
                                            eventEmitter={this.props.eventEmitter}
                                            clearError={this.state.clearErrorKeys.has('videoRecordingStartTime')}
                                        />
                                    </Box>
                                    <StretchRowFlexContainer>
                                        <Box display={'flex'} width={18} minWidth={18} alignItems={'center'}
                                             justifyContent={'center'}>：</Box>
                                    </StretchRowFlexContainer>
                                    <Box width={'50%'}>
                                        <PPSelectForResident
                                            inputProps={{
                                                name: 'videoRecordingStartTime',
                                                value: this.getSelectedTime(videoRecordingStartTime.minutes),
                                            }}
                                            onChange={this.handleChangeMinutes}
                                            options={this.getSelectableMinutes(videoRecordingStartTime.minutes)}
                                            eventKeys={[`videoRecordingStartTime`]}
                                            eventEmitter={this.props.eventEmitter}
                                            clearError={this.state.clearErrorKeys.has('videoRecordingStartTime')}
                                            messageInvisible
                                        />
                                    </Box>
                                </FlexContainer>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'終了時間'}
                        required
                        component={
                            <ErrorMessageAreaWrapper>
                                <FlexContainer>
                                    <Box width={'50%'} minWidth={0}>
                                        <PPSelectForResident
                                            inputProps={{
                                                name: 'videoRecordingEndTime',
                                                value: this.getSelectedTime(videoRecordingEndTime.hours),
                                            }}
                                            onChange={this.handleChangeHours}
                                            options={this.getSelectableHours(videoRecordingEndTime.hours)}
                                            eventKeys={[`videoRecordingEndTime`]}
                                            eventEmitter={this.props.eventEmitter}
                                            clearError={this.state.clearErrorKeys.has('videoRecordingEndTime')}
                                        />
                                    </Box>
                                    <StretchRowFlexContainer>
                                        <Box display={'flex'} width={18} minWidth={18} alignItems={'center'}
                                             justifyContent={'center'}>：</Box>
                                    </StretchRowFlexContainer>
                                    <Box width={'50%'}>
                                        <PPSelectForResident
                                            inputProps={{
                                                name: 'videoRecordingEndTime',
                                                value: this.getSelectedTime(videoRecordingEndTime.minutes),
                                            }}
                                            onChange={this.handleChangeMinutes}
                                            options={this.getSelectableMinutes(videoRecordingEndTime.minutes)}
                                            eventKeys={[`videoRecordingEndTime`]}
                                            eventEmitter={this.props.eventEmitter}
                                            clearError={this.state.clearErrorKeys.has('videoRecordingEndTime')}
                                            messageInvisible
                                        />
                                    </Box>
                                </FlexContainer>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderBrowsePreferredDateForm(): ReactElement {
        const {
            browsePreferredDate,
            browsePreferredStartTime,
            browsePreferredEndTime,
            currentDate,
            holidays,
        } = this.state

        return (
            <>
                <ItemHeading>
                    閲覧の希望日時
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'日付'}
                        required
                        component={
                            <PPDatePickerForResident
                                date={browsePreferredDate}
                                onChange={this.handleChangeBrowsePreferredDate}
                                holidays={holidays}
                                itemValue={''}
                                eventKeys={['browsePreferredDate']}
                                eventEmitter={this.props.eventEmitter}
                                today={currentDate.toDate()}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'開始時間'}
                        required
                        component={
                            <ErrorMessageAreaWrapper>
                                <FlexContainer>
                                    <Box width={'50%'} minWidth={0}>
                                        <PPSelectForResident
                                            inputProps={{
                                                name: 'browsePreferredStartTime',
                                                value: this.getSelectedTime(browsePreferredStartTime.hours),
                                            }}
                                            onChange={this.handleChangeHours}
                                            options={this.getSelectableHours(browsePreferredStartTime.hours)}
                                            eventKeys={[`browsePreferredStartTime`]}
                                            eventEmitter={this.props.eventEmitter}
                                            clearError={this.state.clearErrorKeys.has('browsePreferredStartTime')}
                                        />
                                    </Box>
                                    <StretchRowFlexContainer>
                                        <Box display={'flex'} width={18} minWidth={18} alignItems={'center'}
                                             justifyContent={'center'}>：</Box>
                                    </StretchRowFlexContainer>
                                    <Box width={'50%'}>
                                        <PPSelectForResident
                                            inputProps={{
                                                name: 'browsePreferredStartTime',
                                                value: this.getSelectedTime(browsePreferredStartTime.minutes),
                                            }}
                                            onChange={this.handleChangeMinutes}
                                            options={this.getSelectableMinutes(browsePreferredStartTime.minutes)}
                                            eventKeys={[`browsePreferredStartTime`]}
                                            eventEmitter={this.props.eventEmitter}
                                            clearError={this.state.clearErrorKeys.has('browsePreferredStartTime')}
                                            messageInvisible
                                        />
                                    </Box>
                                </FlexContainer>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'終了時間'}
                        required
                        component={
                            <ErrorMessageAreaWrapper>
                                <FlexContainer>
                                    <Box width={'50%'} minWidth={0}>
                                        <PPSelectForResident
                                            inputProps={{
                                                name: 'browsePreferredEndTime',
                                                value: this.getSelectedTime(browsePreferredEndTime.hours),
                                            }}
                                            onChange={this.handleChangeHours}
                                            options={this.getSelectableHours(browsePreferredEndTime.hours)}
                                            eventKeys={[`browsePreferredEndTime`]}
                                            eventEmitter={this.props.eventEmitter}
                                            clearError={this.state.clearErrorKeys.has('browsePreferredEndTime')}
                                        />
                                    </Box>
                                    <StretchRowFlexContainer>
                                        <Box display={'flex'} width={18} minWidth={18} alignItems={'center'}
                                             justifyContent={'center'}>：</Box>
                                    </StretchRowFlexContainer>
                                    <Box width={'50%'}>
                                        <PPSelectForResident
                                            inputProps={{
                                                name: 'browsePreferredEndTime',
                                                value: this.getSelectedTime(browsePreferredEndTime.minutes),
                                            }}
                                            onChange={this.handleChangeMinutes}
                                            options={this.getSelectableMinutes(browsePreferredEndTime.minutes)}
                                            eventKeys={[`browsePreferredEndTime`]}
                                            eventEmitter={this.props.eventEmitter}
                                            clearError={this.state.clearErrorKeys.has('browsePreferredEndTime')}
                                            messageInvisible
                                        />
                                    </Box>
                                </FlexContainer>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderAccompanyArea(): ReactElement {
        const {accompanyList} = this.state
        return (
            <>
                <ItemHeading>
                    同行者
                </ItemHeading>
                <AccompanyWhiteArea>
                    <TransitionGroup>
                        {accompanyList.map(
                            (accompany, key) => {
                                return (<Collapse key={accompany.key}>
                                    <Box>{accompany.index === 0 ?
                                        <Box height={'15px'}/> : <Box height={'20px'}/>}
                                        {this.renderAccompanyForm(key, accompany)}</Box>
                                </Collapse>)
                            })}
                    </TransitionGroup>
                    {(HKConstants.VRS.PCD.BROWSE_ACCOMPANY_ADD_LIMIT > accompanyList.length)
                        ? <AddButton onClick={this.onClickAddFamilyButton}>
                            <LeftRowFlexContainer>
                                <AddCircle style={circleIconStyle}/>
                                {`同行者を追加する（最大${HKConstants.VRS.PCD.BROWSE_ACCOMPANY_ADD_LIMIT}人まで）`}
                            </LeftRowFlexContainer>
                        </AddButton>
                        : <Box height={'20px'}/>
                    }
                </AccompanyWhiteArea>
            </>
        )
    }

    renderAccompanyForm(
        key: number,
        accompany: NatBrowseApplyAccompany,
    ): ReactElement {
        const {
            index, relationship, accompanyName, zipCode, prefecture, address2, address3, buildingRoomNumber,
        } = accompany

        return (
            <AccompanyArea>
                <AccompanyItemHeading>
                    <FullWidthRowFlexContainer>
                        <LeftColumnFlexContainer>
                            {`同行者${toFullWidthNumber(index + 1)}`}
                        </LeftColumnFlexContainer>
                        <RightColumnFlexContainer>
                            <ClearButton onClick={() => {
                                this.onClickDeleteFamilyButton(index)
                            }}>
                                <LeftRowFlexContainer>
                                    <Clear style={clearIconStyle}/>
                                    取消
                                </LeftRowFlexContainer>
                            </ClearButton>
                        </RightColumnFlexContainer>
                    </FullWidthRowFlexContainer>
                </AccompanyItemHeading>
                <Box p={'0 10px'}>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'同行者名'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 20,
                                    name: `accompany[${index}].accompanyName`,
                                    id: `accompany[${index}].accompanyName`,
                                    value: accompanyName,
                                    placeholder: '例：素敵 太郎',
                                }}
                                onChange={this.handleChangeAccompanyText}
                                data-familyindex={key}
                                eventKeys={[`accompany[${index}].accompanyName`]}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'続柄'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 15,
                                    name: `accompany[${index}].relationship`,
                                    value: relationship,
                                }}
                                data-familyindex={key}
                                onChange={this.handleChangeAccompanyText}
                                eventKeys={[`accompany[${index}].relationship`]}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <GridContainer>
                        <GridItem over={3}/>
                        <GridItem over={9}>
                            <RelationShipNode>
                                例：夫、妻、子など
                            </RelationShipNode>
                        </GridItem>
                    </GridContainer>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'郵便番号（ハイフン不要）'}
                        component={
                            <ErrorMessageAreaWrapper>
                                <FlexContainer>
                                    <Box flex={2} minWidth={0}>
                                        <PPTextFieldForResident
                                            inputProps={{
                                                maxLength: 7,
                                                name: `accompany[${index}].zipCode`,
                                                value: zipCode,
                                                placeholder: '例：1234567',
                                            }}
                                            onChange={this.handleChangeAccompanyText}
                                            data-familyindex={key}
                                            eventKeys={[`accompany[${index}].zipCode`]}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </Box>
                                    <FlexContainer>
                                        <BlockSpacer width={5}/>
                                    </FlexContainer>
                                    <Box flex={1} maxWidth={'160px'} minWidth={'125px'}
                                         maxHeight={'50px'}>
                                        <DefaultStyledButton
                                            onClick={() => this.getAccompanyZipCode(index)}>
                                            住所自動入力
                                        </DefaultStyledButton>
                                    </Box>
                                </FlexContainer>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'都道府県'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 4,
                                    name: `accompany[${index}].prefecture`,
                                    value: prefecture,
                                    placeholder: '例：東京都',
                                }}
                                onChange={this.handleChangeAccompanyText}
                                data-familyindex={key}
                                eventKeys={[`accompany[${index}].prefecture`]}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'市区町村'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: `accompany[${index}].address2`,
                                    value: address2,
                                    placeholder: '例：港区',
                                }}
                                onChange={this.handleChangeAccompanyText}
                                data-familyindex={key}
                                eventKeys={[`accompany[${index}].address2`]}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'番地'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: `accompany[${index}].address3`,
                                    value: address3,
                                    placeholder: '例：芝４－６－６',
                                }}
                                onChange={this.handleChangeAccompanyText}
                                data-familyindex={key}
                                eventKeys={[`accompany[${index}].address3`]}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'建物名・部屋番号'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: `accompany[${index}].buildingRoomNumber`,
                                    value: buildingRoomNumber,
                                    placeholder: '例：すてきマンション　１０１号室',
                                }}
                                onChange={this.handleChangeAccompanyText}
                                data-familyindex={key}
                                eventKeys={[`accompany[${index}].buildingRoomNumber`]}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </Box>
            </AccompanyArea>
        )
    }

    renderNoteForm(): ReactElement {
        const {note} = this.state

        return (
            <>
                <ItemHeading>
                    備考
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={<span>その他閲覧理由、<BreakPcOnly/>同行者など</span>}
                        component={
                            <PPTextAreaForResident
                                inputProps={{
                                    maxLength: 200,
                                    name: 'note',
                                    value: note,
                                    placeholder: '200文字以内',
                                }}
                                onChange={this.handleChangeText}
                                eventKeys={['note']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    render(): ReactElement {
        const {submitButtonLabel} = this.props
        const {applyButtonDisabled} = this.state

        if (!this.state.isLoadCompleted) {
            return (<></>)
        }

        return (
            <>
                {this.renderApplicantForm()}
                < Box height={'15px'}/>
                {this.renderBrowseReasonDetailForm()}
                < Box height={'15px'}/>
                {this.renderConstructionDateForm()}
                < Box height={'15px'}/>
                {this.renderBrowsePreferredDateForm()}
                < Box height={'15px'}/>
                {this.renderAccompanyArea()}
                < Box height={'15px'}/>
                {this.renderNoteForm()}
                <ApplyButton disabled={applyButtonDisabled} onClick={this.onClickApplyConfirmButton}>
                    <FullWidthColumnFlexContainer>
                        <div>
                            {submitButtonLabel}
                        </div>
                    </FullWidthColumnFlexContainer>
                </ApplyButton>
            </>
        )
    }
}

const AccompanyWhiteArea = styled(WideWhiteArea)`
  padding: 0 5px;
`

const AccompanyArea = styled.div`
  border: 1px solid rgba(0, 112, 176, 0.5);
`

const AccompanyItemHeading = styled.div`
  background-color: ${Colors.LightBlue};
  padding: 10px 15px;
  box-sizing: border-box;
  overflow: hidden;
`

const AddButton = styled(UnstyledLinkStyledButton)`
  padding: 20px 20px 20px 0;
  color: ${Colors.Primary};
  font-weight: ${FontWeights.Bold};
  line-height: 24px;
`

const ClearButton = styled(UnstyledLinkStyledButton)`
  color: ${Colors.Alert};
  line-height: 24px;
`

const circleIconStyle = {
    fontSize: FontSize.Big,
    color: Colors.Primary,
    marginRight: '3px',
}

const clearIconStyle = {
    fontSize: FontSize.Big,
    color: Colors.Alert,
    marginRight: '3px',
}

const RelationShipNode = styled(FlexContainer)`
  font-size: ${FontSize.Small};
  color: ${Colors.AccentDark};
  margin-top: 5px;
`

const BreakPcOnly = styled('br')`
  ${currentMedia.lessThan('sp')`
    display: none;
  `};
`
